module.exports = __webpack_public_path__ + "img/xl_bk.0357d6bc.png";